/*
 * Cores Club cart upsell — see snippets/cart-cores-club-upsell.liquid.
 *
 * Accepting the offer does three things, in order:
 *   1. /cart/change.js — put the two Stitch subscription properties on the cores line(s).
 *   2. /cart/update.js — the R400 is a cart-level code, not a line price change. Shopify's discount
 *      engine cannot see the Stitch subscription (it is a line property), so the code has to be
 *      driven from the cart contents. Same contract as custom_liquid_crpAtc1x on the starter kit
 *      product page. GET /discount/<code> is the fallback if that write does not take.
 *   3. Re-render the drawer / cart page so the subtotal and this card both catch up.
 *
 * Between 1 and 2 it also adds the two Cores Club free gifts (any not already in the cart). They are
 * made free by a second code, SUB GIFTS, which rides next to STARTER KIT on every apply.
 *
 * Each of those responses is a full cart object, so every step is read for what the next one needs
 * rather than re-reading /cart.js in between: the accept path is three requests, not seven.
 */
(function () {
  if (window.__crpCcUpsell) return;
  window.__crpCcUpsell = true;

  var LOG = '[CRP Cores Club upsell]';
  var DISCOUNT_CODE = 'STARTER KIT'; // compared upper-case; already upper-case here
  var SUB_OPTION_ID = 'f8747a8f-0db3-4ced-a194-6b5ea8932d6a';
  var SUB_PLAN_NAME = 'Once a month';
  var MAX_CORES_LINES = 5; // loop guard; in practice the kit adds exactly one cores line
  // Free gifts that come with the subscription. SUB GIFTS is a 100%-off code scoped to just these two
  // variants; gift lines carry the hidden GIFT_PROP so they never merge with full-price lines. Same
  // constants as custom_liquid_crpAtc1x on product.sub-switch.json — keep the two in step.
  var GIFT_CODE = 'SUB GIFTS';
  var GIFT_VARIANT_IDS = [67750268829917, 46893525139677];
  var GIFT_PROP = '_crp_gift';
  var SUB_CODES = DISCOUNT_CODE + ',' + GIFT_CODE;

  // There is no dismissal: while a one-time cores bundle sits in the cart the offer stays on screen.
  // It stops showing only once it is taken — the cart gains a subscription line and the Liquid stops
  // rendering the card — or the cores bundle leaves the cart.

  // ---- fetch helpers --------------------------------------------------------
  function getJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status + ' from ' + url);
      return r.json();
    });
  }
  function getCart() {
    return getJSON('/cart.js', { headers: { Accept: 'application/json' } });
  }
  function postJSON(url, body) {
    return getJSON(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // The apply route drops a persistent `discount_code` cookie that /checkout re-reads, so clearing
  // the cart-level code alone is not enough — the cookie would re-apply it at checkout. Wipe it
  // across every host/domain spelling. Mirrors clearDiscountCookie() in the product page script.
  function clearDiscountCookie() {
    var host = location.hostname;
    var base = host.replace(/^www\./, '');
    ['', '; domain=' + host, '; domain=.' + base].forEach(function (dm) {
      document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/' + dm;
      document.cookie = 'discount_code=; Max-Age=0; path=/' + dm;
    });
  }

  // ---- gifts ----------------------------------------------------------------
  function isGiftLine(item) { return !!(item.properties && item.properties[GIFT_PROP]); }
  function isSubLine(item) { return !!(item.properties && item.properties['Subscription plan']); }

  // Line-key -> 0 for every gift line. The gifts are only free with a subscription, so once the cart
  // has none they go rather than reaching checkout at full price.
  function giftRemovals(cart) {
    var updates = {};
    (cart && cart.items || []).forEach(function (item) { if (isGiftLine(item)) updates[item.key] = 0; });
    return updates;
  }

  // The gift lines the cart does not already hold, ready for /cart/add.js.
  function missingGifts(cart) {
    var have = {};
    (cart && cart.items || []).forEach(function (item) { if (isGiftLine(item)) have[item.variant_id] = true; });
    return GIFT_VARIANT_IDS.filter(function (id) { return !have[id]; }).map(function (id) {
      var props = {};
      props[GIFT_PROP] = 'cores-club';
      return { id: id, quantity: 1, properties: props };
    });
  }

  // ---- cart writes ----------------------------------------------------------
  // Convert every one-time cores line into a subscription line. Each pass re-reads the cart rather
  // than iterating a list captured up front: /cart/change.js re-keys (and can move) the line it
  // changes, so indexes and keys captured before the first write go stale. That read is free — the
  // change.js response *is* the updated cart — so `cart` carries it into the next pass and only the
  // first pass costs a /cart.js. Resolves with the final cart.
  function subscribeCoresLines(coresIds, cart, pass) {
    pass = pass || 0;
    if (pass >= MAX_CORES_LINES) return Promise.resolve(cart);

    return (cart ? Promise.resolve(cart) : getCart()).then(function (cart) {
      var target = null;
      (cart.items || []).some(function (item) {
        var isCores = coresIds.indexOf(String(item.variant_id)) !== -1;
        var isSub = item.properties && item.properties['Subscription plan'];
        if (isCores && !isSub) {
          target = item;
          return true;
        }
        return false;
      });
      if (!target) return cart;

      // change.js replaces the line's properties wholesale, so carry the existing ones over.
      var props = {};
      Object.keys(target.properties || {}).forEach(function (k) { props[k] = target.properties[k]; });
      props['_Subscription option_'] = SUB_OPTION_ID;
      props['Subscription plan'] = SUB_PLAN_NAME;

      return postJSON('/cart/change.js', {
        id: target.key,
        quantity: target.quantity,
        properties: props
      }).then(function (updated) {
        return subscribeCoresLines(coresIds, updated, pass + 1);
      });
    });
  }

  // Apply or clear the code, then verify it against the cart and retry once — /cart/update.js is a
  // set-state call, so a stale write landing out of order used to leave the wrong code at checkout.
  //
  // The write goes through /cart/update.js, whose response is the resulting cart: that single response
  // both proves the code landed (discount_codes) and — when sectionIds are passed — carries the
  // re-rendered sections, so the verify and the re-render cost no request of their own. The `discount`
  // field on that endpoint is undocumented, so the retry falls back to GET /discount/<code>: the
  // guaranteed route, but it 302s onto a full storefront page and downloads the whole document.
  //
  // Applying sets both codes; the fallback route only carries STARTER KIT. `updates` (line key ->
  // quantity) rides on the first write only — the heal uses it to take the gifts out with the codes.
  //
  // Resolves with { ok, sections }; `sections` is null whenever the caller must still re-render itself.
  function setDiscount(want, sectionIds, tries, updates) {
    tries = tries || 0;
    var useFallback = want && tries > 0;
    if (!want) clearDiscountCookie();

    var body = { discount: want ? SUB_CODES : '' };
    if (updates && tries === 0 && Object.keys(updates).length) body.updates = updates;
    if (sectionIds && !useFallback) {
      body.sections = sectionIds;
      body.sections_url = location.pathname;
    }

    var write = useFallback
      ? fetch('/discount/' + encodeURIComponent(DISCOUNT_CODE), { redirect: 'follow' }).then(getCart)
      : postJSON('/cart/update.js', body);

    return write
      .catch(function () { return getCart().catch(function () { return null; }); })
      .then(function (cart) {
        if (!cart) {
          console.error(LOG, 'discount sync failed: cart unreadable');
          return { ok: false, sections: null };   // leave the cart as-is
        }
        var codes = (cart.discount_codes || []).map(function (d) {
          return String(d.code || '').toUpperCase();
        });
        // Applied means both codes are on; cleared means neither is.
        var hasMain = codes.indexOf(DISCOUNT_CODE) !== -1;
        var hasGift = codes.indexOf(GIFT_CODE) !== -1;
        var applied = want ? (hasMain && hasGift) : (hasMain || hasGift);
        if (applied === want) return { ok: true, sections: cart.sections || null };
        if (tries >= 1) {
          console.error(LOG, 'discount still wrong after retry (want ' + (want ? 'applied' : 'clear') + ')');
          return { ok: false, sections: null };
        }
        console.warn(LOG, 'discount state mismatch, retrying (want ' + (want ? 'applied' : 'clear') + ')');
        return setDiscount(want, sectionIds, tries + 1);
      });
  }

  // ---- re-render ------------------------------------------------------------
  function sectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector || '.shopify-section');
    return node ? node.innerHTML : null;
  }

  // Drawer: hand the sections to the theme's own renderer. CartDrawer keys the payload by
  // descriptor .id (which is the section id: cart-drawer, cart-icon-bubble) and rebuilds the whole
  // of #CartDrawer, footer and this card included. Same call the starter kit ATC script makes.
  function drawerPlan() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.renderContents !== 'function') {
      return null;
    }
    var ids;
    try { ids = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e) { return null; }
    if (!ids.length) return null;
    return {
      ids: ids,
      apply: function (sections) { drawer.renderContents({ sections: sections }); }
    };
  }

  // Cart page: CartItems.onCartUpdate() only re-fetches main-cart-items, so leaning on it would
  // leave the subtotal showing the pre-discount total. Swap the sections here instead. Its
  // descriptors carry a separate .section (the template's section id) and .selector.
  function cartPagePlan() {
    var cartItems = document.querySelector('cart-items');
    var specs = null;
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      try { specs = cartItems.getSectionsToRender(); } catch (e) { specs = null; }
    }
    if (specs) {
      specs = specs.filter(function (s) { return s && s.section && document.getElementById(s.id); });
    }
    if (!specs || !specs.length) return null;
    return {
      ids: specs.map(function (s) { return s.section; }),
      apply: function (sections) {
        specs.forEach(function (spec) {
          var html = sections[spec.section];
          var host = document.getElementById(spec.id);
          if (!html || !host) return;
          var target = (spec.selector && host.querySelector(spec.selector)) || host;
          var inner = sectionInnerHTML(html, spec.selector);
          if (inner !== null) target.innerHTML = inner;
        });
      }
    };
  }

  // Which sections this context needs, and how to put the returned HTML back. Split out from
  // refresh() so the section ids can be handed to the discount write, which then returns the rendered
  // HTML in its own response — one request for the write, the verify and the re-render together.
  // `ids` is a list here; planIds() joins whatever set of plans a caller ends up with.
  // Returns null when neither renderer is available and only a reload will do.
  function renderPlan(card) {
    var inDrawer = card && card.closest ? card.closest('cart-drawer') : null;
    if (inDrawer) {
      var drawer = drawerPlan();
      if (drawer) return drawer;
    }
    return cartPagePlan();
  }

  // Every context on the page, not just the one holding a given card. The heal below runs off a
  // marker it did not choose — on /cart the drawer's marker comes first in the document — so
  // re-rendering only that marker's context left the page the shopper is actually looking at showing
  // the discount it had just cleared. Most-visible context first: on /cart that is the page itself,
  // and the ids cap below spends its budget in that order.
  function renderPlans() {
    var page = cartPagePlan();
    var drawer = drawerPlan();
    return (page ? [page, drawer] : [drawer, page]).filter(Boolean);
  }

  // One de-duplicated ids string for the whole set; each plan then picks its own keys back out of the
  // single sections payload the write returns. The Section Rendering API serves at most 5 sections per
  // request, and the drawer and the cart page together can reach that, so the list is capped rather
  // than risking an error that would re-render nothing. Both share cart-icon-bubble, which dedupes.
  var MAX_SECTIONS = 5;
  function planIds(plans) {
    var seen = {};
    var ids = [];
    plans.forEach(function (plan) {
      plan.ids.forEach(function (id) {
        if (seen[id] || ids.length >= MAX_SECTIONS) return;
        seen[id] = true;
        ids.push(id);
      });
    });
    return ids.length ? ids.join(',') : null;
  }

  // A plan whose sections did not all come back is left alone: half-rendering a context is worse than
  // leaving it showing figures one cart update behind.
  function applyPlans(plans, sections) {
    plans.forEach(function (plan) {
      var complete = plan.ids.every(function (id) { return sections && sections[id]; });
      if (!complete) return;
      try { plan.apply(sections); } catch (e) { console.warn(LOG, 're-render failed', e); }
    });
  }

  // Fetch the sections ourselves. Only needed when the write could not carry them — the /discount/
  // fallback ran, or the response came back without a sections payload.
  function refresh(card, plan) {
    plan = plan || renderPlan(card);
    return refreshPlans(plan ? [plan] : []);
  }

  function refreshPlans(plans) {
    var ids = plans.length ? planIds(plans) : null;
    if (!ids) {
      window.location.reload();
      return new Promise(function () {}); // never settles; the page is on its way out
    }
    return getJSON(location.pathname + '?sections=' + encodeURIComponent(ids))
      .then(function (sections) { applyPlans(plans, sections); })
      .catch(function (e) {
        console.error(LOG, 'refresh failed', e);
        window.location.reload();
      });
  }

  // ---- actions --------------------------------------------------------------
  function accept(card) {
    if (card.getAttribute('data-crp-ccu-busy') === '1') return;
    card.setAttribute('data-crp-ccu-busy', '1');

    var btn = card.querySelector('[data-crp-ccu-accept]');
    var label = card.querySelector('[data-crp-ccu-label]');
    var error = card.querySelector('[data-crp-ccu-error]');
    var originalLabel = label ? label.textContent : '';

    if (error) error.hidden = true;
    if (btn) btn.disabled = true;
    if (label) label.textContent = 'Switching…';

    var coresIds = (card.getAttribute('data-cores-variant-ids') || '')
      .split(',')
      .filter(function (id) { return id; });

    // The card renders the one-time cores lines it will switch, so the first change.js can go out
    // without a /cart.js read. If those keys have gone stale the write fails, and it starts over from a
    // fresh read — change.js either lands or leaves the line untouched, so nothing is half-done.
    var seed = null;
    try {
      var lines = JSON.parse(card.getAttribute('data-one-time-cores') || '[]');
      if (lines.length) seed = { items: lines };
    } catch (e) { seed = null; }

    subscribeCoresLines(coresIds, seed)
      .catch(function (e) {
        if (!seed) throw e;
        console.warn(LOG, 'rendered cores lines were stale, re-reading the cart', e);
        return subscribeCoresLines(coresIds);
      })
      .then(function (cart) {
        // Never hand out the code off the back of a write that did not land — the discount is the
        // whole R400 and Shopify cannot tell on its own that the cart earned it. change.js answered
        // with the updated cart, so this reads that rather than costing another /cart.js.
        var hasSub = (cart && cart.items || []).some(isSubLine);
        if (!hasSub) throw new Error('no subscription line after the change; not applying ' + DISCOUNT_CODE);

        var plan = renderPlan(card);
        var ids = plan && planIds([plan]);
        var gifts = missingGifts(cart);
        if (!gifts.length) {
          return setDiscount(true, ids).then(function (res) {
            // The happy path ends here: the update.js response already carried the rendered sections.
            if (plan && res.sections) return plan.apply(res.sections);
            return refresh(card, plan);
          });
        }
        // Codes first, gifts second: the gifts then land already discounted, and the add renders the
        // sections, so the drawer never shows them at full price for a beat. Same request count as
        // applying the codes last. A failed gift add is logged and swallowed — the subscription and the
        // R400 still stand.
        return setDiscount(true, null).then(function () {
          var body = { items: gifts };
          if (ids) { body.sections = ids; body.sections_url = location.pathname; }
          return postJSON('/cart/add.js', body).catch(function (e) {
            console.error(LOG, 'could not add the free gifts', e);
            return null;
          });
        }).then(function (res) {
          if (plan && res && res.sections) return plan.apply(res.sections);
          return refresh(card, plan);
        });
      })
      .catch(function (e) {
        console.error(LOG, 'could not switch to the subscription', e);
        card.removeAttribute('data-crp-ccu-busy');
        if (btn) btn.disabled = false;
        if (label) label.textContent = originalLabel;
        if (error) error.hidden = false;
      });
  }

  // ---- state sync -----------------------------------------------------------
  // The R400 rides on a cart-level code, so it has to be pulled back the moment the cart stops
  // holding a subscription line — otherwise accepting the offer and then removing the kit would carry
  // R400 off whatever is left through to checkout. `healedFor` keeps this to one write per state.
  var healing = false;
  var healedFor = null;
  // Every marker on the page renders the same cart, so one of them speaks for all: /cart and the
  // drawer each render the snippet, and healing per-marker meant the first (the drawer's, which
  // theme.liquid prints before <main>) decided which context got re-rendered.
  function healDiscount() {
    var marker = document.querySelector('[data-crp-ccu-marker]');
    if (!marker) return;

    // Also heals a cart left holding the free gifts without a subscription line.
    var codeApplied = marker.getAttribute('data-code-applied') === 'true';
    var hasSub = marker.getAttribute('data-cart-has-sub') === 'true';
    var hasGift = marker.getAttribute('data-cart-has-gift') === 'true';
    var state = codeApplied + '|' + hasSub + '|' + hasGift;
    if (hasSub || !(codeApplied || hasGift)) {
      healedFor = null;
      return;
    }
    if (healing || healedFor === state) return;
    healing = true;
    console.warn(LOG, 'cart carries ' + DISCOUNT_CODE + ' or the free gifts with no subscription line — clearing');
    // Re-render every context the page has, not just the marker's: on /cart both the drawer and the
    // cart sections are live, and leaving either behind shows a total the cart no longer holds.
    // The marker renders the gift line keys, so the codes and the gifts go in one write with no
    // /cart.js read first. A stale key fails that write; setDiscount's retry then clears the codes, and
    // the next render (still showing a gift) heals again with fresh keys.
    var removals = {};
    (marker.getAttribute('data-gift-keys') || '').split(',').forEach(function (key) {
      if (key) removals[key] = 0;
    });
    var plans = renderPlans();
    setDiscount(false, planIds(plans), 0, removals).then(function (res) {
      healing = false;
      healedFor = state;
      // Re-render so the total on screen agrees with the cart we just wrote. The next render reports
      // the code as cleared, which resets healedFor and stops this from going round again.
      if (plans.length && res.sections) applyPlans(plans, res.sections);
      else refreshPlans(plans);
    }).catch(function (e) {
      // Nothing above is expected to reject, but a stuck `healing` would disable the pull-back for
      // the rest of the session, which is the one failure this must not have.
      healing = false;
      console.error(LOG, 'discount heal failed', e);
    });
  }

  // Removing the last subscription line. Left to the theme, that is two round trips: its change.js
  // re-renders the cart, and only then does the heal notice the gifts and codes and write again, so
  // the gifts linger for a beat. Instead this takes the line, the gifts and both codes out in one
  // update.js. Captured on the document so it runs before the theme's own handler on the button.
  // Anything else (another subscription line still in the cart, missing markup) goes to the theme,
  // and the heal stays the safety net.
  function removeLastSub(e) {
    var removeEl = e.target && e.target.closest ? e.target.closest('cart-remove-button') : null;
    if (!removeEl) return;
    var marker = document.querySelector('[data-crp-ccu-marker]');
    if (!marker) return;

    var subLines = {};
    (marker.getAttribute('data-sub-lines') || '').split(',').forEach(function (pair) {
      var i = pair.indexOf('=');
      if (i > 0) subLines[pair.slice(0, i)] = pair.slice(i + 1);
    });
    var key = subLines[removeEl.getAttribute('data-index')];
    if (!key || Object.keys(subLines).length !== 1) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (removeEl.getAttribute('data-crp-ccu-removing') === '1') return;
    removeEl.setAttribute('data-crp-ccu-removing', '1');

    var row = removeEl.closest('.cart-item');
    var overlay = row && row.querySelector('.loading-overlay');
    if (overlay) overlay.classList.remove('hidden');

    var updates = {};
    updates[key] = 0;
    (marker.getAttribute('data-gift-keys') || '').split(',').forEach(function (k) { if (k) updates[k] = 0; });

    clearDiscountCookie();
    var plans = renderPlans();
    var ids = planIds(plans);
    var body = { updates: updates, discount: '' };
    if (ids) { body.sections = ids; body.sections_url = location.pathname; }
    postJSON('/cart/update.js', body)
      .then(function (cart) {
        // The theme's own remove flags an emptied drawer; do the same, since its handler never ran.
        var drawer = document.querySelector('cart-drawer');
        if (drawer && cart.item_count === 0) drawer.classList.add('is-empty');
        if (plans.length && cart.sections) applyPlans(plans, cart.sections);
        else refreshPlans(plans);
      })
      .catch(function (err) {
        // Nothing was written (a stale key fails the whole call); re-render so the shopper can retry.
        console.error(LOG, 'could not remove the subscription line', err);
        refreshPlans(plans);
      });
  }
  document.addEventListener('click', removeLastSub, true);

  function apply() {
    healDiscount();

    // Rendered hidden in the markup (see the snippet) purely to avoid a flash before the script is
    // ready to handle the click; there is no dismissal, so reveal it unconditionally.
    [].forEach.call(document.querySelectorAll('[data-crp-ccu]'), function (card) {
      card.hidden = false;
    });
  }

  // ---- checkout guard -------------------------------------------------------
  // Last line of defence: whatever the cart on screen says, the code and the cart are re-reconciled
  // on the way to checkout. The same guard lives in custom_liquid_crpAtc1x on the starter kit product
  // page, but that page is the only place it used to load — leaving checkout from the drawer on any
  // other page, or from /cart, ran no check at all, so a stale code went through to checkout.
  //
  // Same contract as that copy (read the cart, force the outcome through the URL, 3s hard cap so a
  // slow or failed /cart.js can never strand the shopper), but bound defensively — see below. The
  // shared __crpCheckoutHook flag means only one of the two ever binds; on the starter kit page the
  // inline copy still gets there first.
  if (!window.__crpCheckoutHook) {
    window.__crpCheckoutHook = true;
    // Bubble phase, and only once nothing else has objected: the theme's T&C checkbox gate
    // (TncCheckbox in secondary.js) is a click listener on the checkout button itself that
    // preventDefault()s until the box is ticked, and the drawer's inline checkoutLoad() spinner also
    // runs on the button. Capturing here — or stopping propagation — would walk straight through both.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest
        ? e.target.closest('button[name="checkout"], .cart__checkout-button, input[name="checkout"]')
        : null;
      if (!btn) return;
      if (e.defaultPrevented) return;  // something is holding this click back; leave it held back
      e.preventDefault();
      var navDone = false;
      var go = function (url) { if (!navDone) { navDone = true; window.location.href = url; } };
      setTimeout(function () { go('/checkout'); }, 3000);
      getCart()
        .then(function (cart) {
          var hasSub = (cart.items || []).some(isSubLine);
          if (hasSub) {
            // Both codes go on through update.js; the single-code /discount/ route is the fallback so
            // the R400 still lands if that write fails.
            postJSON('/cart/update.js', { discount: SUB_CODES }).then(function () { go('/checkout'); }, function () {
              go('/discount/' + encodeURIComponent(DISCOUNT_CODE) + '?redirect=' + encodeURIComponent('/checkout'));
            });
            return;
          }
          clearDiscountCookie();
          postJSON('/cart/update.js', { discount: '', updates: giftRemovals(cart) }).then(function () { go('/checkout'); }, function () { go('/checkout'); });
        })
        .catch(function () { go('/checkout'); });
    });
  }

  // ---- wiring ---------------------------------------------------------------
  // Delegated, because the drawer and the cart footer both replace this markup on every cart update.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var acceptBtn = e.target.closest('[data-crp-ccu-accept]');
    if (acceptBtn) {
      e.preventDefault();
      var card = acceptBtn.closest('[data-crp-ccu]');
      if (card) accept(card);
    }
  });

  // Re-run after every cart re-render. Scoped to the two containers the theme swaps rather than the
  // whole document, and coalesced into one frame so a burst of mutations costs a single pass.
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      apply();
    });
  }

  function observe() {
    var targets = [];
    ['#CartDrawer', '#main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) targets.push(el);
    });
    if (!targets.length) targets.push(document.body);

    var observer = new MutationObserver(schedule);
    targets.forEach(function (t) { observer.observe(t, { childList: true, subtree: true }); });
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();

  // bfcache restores can bring back a drawer rendered before the dismissal (or before a cart change).
  window.addEventListener('pageshow', schedule);
})();
